<template>
    <pt-skeleton :loading="true" :class="[$style.container, props.size && $style[props.size]]">
        <template #template>
            <header>
                <pt-skeleton-item
                    variant="text"
                    style="width: 90px; margin-right: 16px; background: #dfe1e6"
                />
                <pt-skeleton-item
                    variant="text"
                    style="width: 90px; margin-right: 16px; background: #dfe1e6"
                />
                <pt-skeleton-item
                    variant="text"
                    style="width: 90px; margin-right: 16px; background: #dfe1e6"
                />
                <pt-skeleton-item
                    variant="text"
                    style="width: 90px; margin-right: 16px; background: #dfe1e6"
                />
            </header>
            <div :class="$style.banner"></div>
            <section>
                <ul v-for="i in 3" :key="i">
                    <li v-for="j in 12" :key="j">
                        <pt-skeleton-item style="background: #dfe1e6" variant="text" />
                    </li>
                </ul>
            </section>
        </template>
    </pt-skeleton>
</template>

<script lang="ts">
export default {
    name: 'PcSkeleton',
    components: {}
};
</script>
<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
interface Props {
    size?: string;
}
const props = defineProps<Props>();
</script>

<style lang="scss" module>
.container {
    header {
        height: 64px;
        padding: 28px 0 0 80px;
    }
    .banner {
        height: 300px;
        background-color: #dfe1e6;
    }

    section {
        margin-top: 44px;
        padding: 0 80px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        gap: 0px 44px;
        grid-template-areas: '. . .';

        ul > li > div {
            height: 12px;
        }
        ul > li {
            &:nth-last-of-type(5),
            &:nth-last-of-type(7) {
                & > div {
                    width: 40%;
                }
            }
        }
        ul > li:first-child > div {
            height: 160px;
        }
    }
    &.small {
        header {
            height: 42px;
            padding: 10px 0 0 40px;
            :global {
                .pt-skeleton__text {
                    height: 8px;
                }
            }
        }
        .banner {
            height: 200px;
        }
        section {
            margin-top: 20px;
            padding: 0 40px;
            ul > li > div {
                height: 6px;
            }
            ul > li:first-child > div {
                height: 120px;
            }
        }
    }
}
</style>
